"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const listParse_1 = __importDefault(require("../lib/listParse"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('f', (context, args) => {
    let result = '';
    let array = listParse_1.default(args[0]);
    for (let x of array) {
        context.setVariable(args[1], x);
        result += context.getValueOfVariable(args[2]);
    }
    return result;
});
